module.exports = __webpack_public_path__ + "img/14.5dca0078.jpeg";